<pbc-filter-preset
  [filter]="umkreissuche.preset$ | async"
  [filters]="umkreissuche.presets$ | async"
  [name]="umkreissuche.search$ | async"
  (select)="umkreissuche.setFilter($event)"
  (save)="umkreissuche.writeFilter($event)"
  (delete)="umkreissuche.deleteFilter($event)"
></pbc-filter-preset>
